<template>
  <div class="ei-long-figure-scroll-auto">
    <div class="ei-long-figure-scroll">
    <div class="scroll-bg" :style="{animationDuration:duration_bg+'s',width:bgWidth+'px'}">
      <img src="./_ei-long-figure-scroll/background.png" alt="">
    </div>
    <div class="scroll-content">
      <ul class="scroll-list" id="scroll-list" :style="{animationDuration:duration+'s',width:listWidth+'px'}"  v-if="this.styleName===undefined">
        <li :class="{'scroll-item':true,'little-hand':item.link!=null }" v-for="(item,index) in taBenAttaches"
            :key="index" @click="toWorksDetail(item.link)">
          <img :class="{'primaryColor':item.moreStyle==='1'}" :src="item.url" alt="[图片]">
        </li>
        <li :class="{'scroll-item':true,'blackYellow-bg':item.moreStyle==='1','little-hand':item.link!=null}" v-for="(item,index) in taBenAttaches"
            :key="'blackYellow'+index" @click="toWorksDetail(item.link)">
          <img :class="{'blackYellow':item.moreStyle==='1'}" :src="item.url" alt="[图片]">
        </li>
        <li :class="{'scroll-item':true,'whiteText-bg':item.moreStyle==='1','little-hand':item.link!=null}" v-for="(item,index) in taBenAttaches"
            :key="'whiteTextx'+index" @click="toWorksDetail(item.link)">
          <img :class="{'whiteText':item.moreStyle==='1'}" :src="item.url" alt="[图片]">
        </li>
        <li :class="{'scroll-item':true,'nobgDiscoloration-bg':item.moreStyle==='1','little-hand':item.link!=null }"
            v-for="(item,index) in taBenAttaches"
            :key="'nobgDiscoloration1'+index" @click="toWorksDetail(item.link)">
          <img :class="{'nobgDiscoloration':item.moreStyle==='1'}" :src="item.url " alt="[图片]">
        </li>
        <li :class="{'scroll-item':true,'blackYellow-bg':item.moreStyle==='1','little-hand':item.link!=null}" v-for="(item,index) in taBenAttaches"
            :key="'blackYellowb'+index" @click="toWorksDetail(item.link)">
          <img :class="{'blackYellow':item.moreStyle==='1'}" :src="item.url" alt="[图片]">
        </li>
        <li :class="{'scroll-item':true,'blackText-bg':item.moreStyle==='1','little-hand':item.link!=null}" v-for="(item,index) in taBenAttaches"
            :key="'blackText'+index" @click="toWorksDetail(item.link)">
          <img :class="{'blackText':item.moreStyle==='1'}" :src="item.url" alt="[图片]">
        </li>
        <li :class="{'scroll-item':true,'colorTurnsBlack-bg':item.moreStyle==='1','little-hand':item.link!=null }"
            v-for="(item,index) in taBenAttaches"
            :key="'colorTurnsBlack'+index" @click="toWorksDetail(item.link)">
          <img :class="{'colorTurnsBlack':item.moreStyle==='1'}" :src="item.url " alt="[图片]">
        </li>
        <li :class="{'scroll-item':true,'blackYellow-bg':item.moreStyle==='1','little-hand':item.link!=null}" v-for="(item,index) in taBenAttaches"
            :key="'blackYellowa'+index" @click="toWorksDetail(item.link)">
          <img :class="{'blackYellow':item.moreStyle==='1'}" :src="item.url" alt="[图片]">
        </li>
        <li :class="{'scroll-item':true,'whiteText-bg':item.moreStyle==='1','little-hand':item.link!=null}" v-for="(item,index) in taBenAttaches"
            :key="'whiteText'+index" @click="toWorksDetail(item.link)">
          <img :class="{'whiteText':item.moreStyle==='1'}" :src="item.url" alt="[图片]">
        </li>
      </ul>

      <ul class="scroll-list"  :style="{animationDuration:duration+'s',width:listWidth+'px'}" v-else-if="styleName==='原色'">
        <li :class="{'scroll-item':true,'little-hand':item.link!=null}" v-for="(item,index) in taBenAttaches"
            :key="index" @click="toWorksDetail(item.link)">
          <img :class="{'primaryColor':item.moreStyle==='1' }" :src="item.url" alt="[图片]">
        </li>
        <li :class="{'scroll-item':true,'little-hand':item.link!=null}" v-for="(item,index) in taBenAttaches"
            :key="'primaryColor'+index" @click="toWorksDetail(item.link)">
          <img :class="{'primaryColor':item.moreStyle==='1' }" :src="item.url" alt="[图片]">
        </li>
      </ul>

      <ul class="scroll-list"  :style="{animationDuration:duration+'s',width:listWidth+'px'}" v-else-if="styleName==='拓本'">
        <li :class="{'scroll-item':true,'whiteText-bg':item.moreStyle==='1','little-hand':item.link!=null}" v-for="(item,index) in taBenAttaches"
            :key="'whiteTextx'+index" @click="toWorksDetail(item.link)">
          <img :class="{'whiteText':item.moreStyle==='1'}" :src="item.url" alt="[图片]">
        </li>
        <li :class="{'scroll-item':true,'whiteText-bg':item.moreStyle==='1','little-hand':item.link!=null}" v-for="(item,index) in taBenAttaches"
            :key="'whiteText'+index" @click="toWorksDetail(item.link)">
          <img :class="{'whiteText':item.moreStyle==='1'}" :src="item.url" alt="[图片]">
        </li>
      </ul>

      <ul class="scroll-list"  :style="{animationDuration:duration+'s',width:listWidth+'px'}" v-else-if="styleName==='墨本'">
        <li :class="{'scroll-item':true,'blackText-bg':item.moreStyle==='1','little-hand':item.link!=null}" v-for="(item,index) in taBenAttaches"
            :key="'blackTextx'+index" @click="toWorksDetail(item.link)">
          <img :class="{'blackText':item.moreStyle==='1'}" :src="item.url" alt="[图片]">
        </li>
        <li :class="{'scroll-item':true,'blackText-bg':item.moreStyle==='1','little-hand':item.link!=null}" v-for="(item,index) in taBenAttaches"
            :key="'blackText'+index" @click="toWorksDetail(item.link)">
          <img :class="{'blackText':item.moreStyle==='1'}" :src="item.url" alt="[图片]">
        </li>
      </ul>

      <ul class="scroll-list"  :style="{animationDuration:duration+'s',width:listWidth+'px'}" v-else-if="styleName==='金彩'">
        <li :class="{'scroll-item':true,'blackYellow-bg':item.moreStyle==='1','little-hand':item.link!=null}" v-for="(item,index) in taBenAttaches"
            :key="'blackYellow'+index" @click="toWorksDetail(item.link)">
          <img :class="{'blackYellow':item.moreStyle==='1'}" :src="item.url" alt="[图片]">
        </li>
        <li :class="{'scroll-item':true,'blackYellow-bg':item.moreStyle==='1','little-hand':item.link!=null}" v-for="(item,index) in taBenAttaches"
            :key="'blackYellowa'+index" @click="toWorksDetail(item.link)">
          <img :class="{'blackYellow':item.moreStyle==='1'}" :src="item.url" alt="[图片]">
        </li>
      </ul>

      <ul class="scroll-list"  :style="{animationDuration:duration+'s',width:listWidth+'px'}" v-else-if="styleName==='七彩'">
        <li :class="{'scroll-item':true,'nobgDiscoloration-bg':item.moreStyle==='1','little-hand':item.link!=null }"
            v-for="(item,index) in taBenAttaches"
            :key="'nobgDiscoloration'+index" @click="toWorksDetail(item.link)">
          <img :class="{'nobgDiscoloration':item.moreStyle==='1'}" :src="item.url " alt="[图片]">
        </li>
        <li :class="{'scroll-item':true,'nobgDiscoloration-bg':item.moreStyle==='1','little-hand':item.link!=null }"
            v-for="(item,index) in taBenAttaches"
            :key="'nobgDiscoloration1'+index" @click="toWorksDetail(item.link)">
          <img :class="{'nobgDiscoloration':item.moreStyle==='1'}" :src="item.url " alt="[图片]">
        </li>
      </ul>

    </div>
    <div class="bottom-scroll-text">
      <span class="scroll-text" id="scroll-text"
            :style="{animationDuration:duration_text+'s'}">{{ headText }}</span>
      <img src="./_ei-long-figure-scroll/text-decorate.png" alt="">
      <img src="./_ei-long-figure-scroll/text-decorate.png" alt="">
    </div>
      <div class="jindutiaoBg">

      </div>
      <div :style="{animationDuration:this.jindutiaoDuration+'s'}" :class="{'jindutiao':true,'jindutiaoDiv':true}">
      </div>
    </div>

    <div class="scrollStyleState">
      <ul>
        <li id="quan">
          <span @click="styleSwitching()" >全样式</span>
        </li>
        <li id="yuanse">
          <span @click="styleSwitching('原色')" >原色</span>
        </li>
        <li id="taben">
          <span @click="styleSwitching('拓本')" >拓本</span>
        </li>
        <li id="moben">
          <span @click="styleSwitching('墨本')" >墨本</span>
        </li>
        <li id="jincai">
          <span @click="styleSwitching('金彩')" >金彩</span>
        </li>
        <li id="qicai">
          <span @click="styleSwitching('七彩')" >炫彩</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'

export default {
  name: 'EiLongFigureScrollForPaint',
  data () {
    return {
      rowGuid:'',
      styleName: '',
      night:9,
      duration: 0,
      taBenUrl: '',
      moreStyle: false,
      taBenAttaches: [],
      duration_text: 0,
      duration_bg:0,
      listWidth: 0,
      bgWidth:4167,
      jindutiaoDuration:0,
    }
  },
  props: {
    speed: {
      type: Number,
      default: 150
    },
    attaches: {
      type: Array,
      required: true,
    },
    text: {
      type: String,
      default: ''
    },
    textImg: {
      type: String,
      default: ''
    },
    works: {
      type: Object,
      required: true,
    },
    headText: {
      type: String,
      required: true,
    }
  },
  watch: {
    attaches: function (newVal, oldVal) {
      this.attaches = newVal
      this.initKeyframes_Img()
    },
  },
  created () {
    this.rowGuid = this.$route.query.guid
    this.styleName = this.$route.query.stytle
  },
  mounted() {
    if (this.styleName==='' || this.styleName===undefined){
      let quan = document.getElementById("quan");
      quan.className="testa"
    }else if(this.styleName==='拓本'){
      let taben = document.getElementById("taben");
      taben.className="testa"
    }else if(this.styleName==='原色'){
      let yuanse = document.getElementById("yuanse");
      yuanse.className="testa"
    }else if(this.styleName==='墨本'){
      let moben = document.getElementById("moben");
      moben.className="testa"
    }else if(this.styleName==='金彩'){
      let jincai = document.getElementById("jincai");
      jincai.className="testa"
    }else if(this.styleName==='七彩'){
      let qicai = document.getElementById("qicai");
      qicai.className="testa"
    }
  },
  updated () {
    this.initKeyframes_Text()
    this.initKeyframes_Bg()
  },
  methods: {
    toWorksDetail(link){
      if (link){
        this.$router.push({
          path: '/WorksDetail',
          query: {guid: link},
        })
      }
    },
    styleSwitching(stytle) {
      if (stytle===''){
        this.$router.push({
          path: '/WorksDetail',
          query: {guid:this.rowGuid},
        })
        this.$router.go(0)
      }
      this.$router.push({
        path: '/WorksDetail',
        query: {guid:this.rowGuid,stytle}
      })
      this.$router.go(0)
    },
    initKeyframes_Bg () {
      let startX = -this.bgWidth
      let endX = 1920
      this.duration_bg = (endX - startX) / this.speed
      let style = document.createElement('style')
      document.getElementsByTagName('head')[0].appendChild(style)
      style.appendChild(document.createTextNode(''))
      document.styleSheets[document.styleSheets.length - 1].insertRule(`
                @keyframes scrollBg{
                0%{ transform: translate(${startX}px,0);}
                100%{transform: translate(${endX}px,0);}
            }
          `)
    },
    initKeyframes_Img () {
      if (this.styleName!==undefined){
        this.night=2;
      }else {
        this.night=9;
      }
      let totalWidth = 0
      for (let i = 0; i < this.attaches.length; i++) {
        if (this.attaches[i].moreStyle === '1') {
          this.moreStyle = true
        }
        totalWidth += this.attaches[i].imgWidth
      }
      /*this.oneTotalWidth=totalWidth*/
      if (this.moreStyle) {
        totalWidth = this.night * totalWidth
        this.taBenAttaches = _.cloneDeep(this.attaches)
      }
      this.listWidth = totalWidth
      let startX = -totalWidth
      let endX = 1920
      this.duration = (endX - startX) / this.speed
      this.jindutiaoDuration =  this.duration/this.night
     /* this.speedWidth=this.duration/this.night
      this.start()*/
      let style = document.createElement('style')
      document.getElementsByTagName('head')[0].appendChild(style)
      style.appendChild(document.createTextNode(''))
      document.styleSheets[document.styleSheets.length - 1].insertRule(`
            @keyframes scroll{
               0%{transform: translate(${startX}px,0);}
               100%{ transform: translate(${endX}px,0);}
            }
          `)
    },
    initKeyframes_Text () {
      let textWidth = document.querySelector('#scroll-text').offsetWidth
      let startX = -textWidth - 180
      let endX = 1920
      this.duration_text = (endX - startX) / this.speed
      let style = document.createElement('style')
      document.getElementsByTagName('head')[0].appendChild(style)
      document.styleSheets[document.styleSheets.length - 1].insertRule(`
            @keyframes scrollText{
              from{filter: hue-rotate(0deg);transform: translate(${startX}px,0); }
               to{transform: translate(${endX}px,0);filter: hue-rotate(360deg);}
               }
          `)
    },
  }
}
</script>
<style scoped lang="scss">
.little-hand{
  cursor: pointer;
}
.jindutiaoBg {
  position: absolute;
  width: 1895px;
  height: 0.5px;
  margin-top: -17px;
  border-radius: 25px;
  background: linear-gradient(150deg,#ff0100,#ffef00 ,#33ff00, #00ff92 ,#00aaff ,#3200ff , #ff00fb ,#ff0002);
  -webkit-background-clip: content-box;
  -webkit-text-fill-color: transparent;
  animation: jindutiaoBg 1s infinite linear;
  z-index: 1;
  @keyframes jindutiaoBg {
    to{
      filter: hue-rotate(-360deg);
    }
  }
}

.jindutiao {
  position: absolute;
  width: 1903px;
  height: 0.5px;
  margin-top: -17px;
  border-radius: 25px;
  margin-left: 0;
  background-color: #faf9f9;
  animation: jindutiao infinite linear;
  z-index: 3;
  @keyframes jindutiao {
    0% {
      margin-left: 0px;
    }
    100% {
      margin-left: 1903px;
    }
  }
}

.testa{
  display: inline-block;
  margin-left: 25px;
  border: 5px solid;
  border-image: linear-gradient(150deg, gold, deeppink) 19;
  clip-path: inset(1px round 10px);
  animation: scrollStyleState-li 3s infinite linear;
  background-color: yellow;

  span {
    padding-left: 5px;
    text-align: center;
    letter-spacing: 5px;
    font-size: 22px;
    cursor: pointer;
    background-color: red;
  }

  span:hover {
    background-color: #C78100;
    color: yellow;
  }
  @keyframes scrollStyleState-li {
    0% {
      filter: hue-rotate(0deg);
    }
    100% {
      filter: hue-rotate(360deg);
    }
  }
}

.scrollStyleState {
  position: absolute;
  margin-left: 155px;
  margin-top: 350px;
  z-index: 999;

  ul {
    margin-top: -30px;
    margin-left: 95px;
    list-style: none
  }

  li {
    display: inline-block;
    margin-left: 10px;
  }

  span {
    border: 1px solid;
    padding-left: 5px;
    text-align: center;
    letter-spacing: 4px;
    background-color: white;
    font-size: 22px;
    border-radius: 10px;
    cursor: pointer;
  }
  span:hover{
    background-color: #C78100;
    color: yellow;
  }
}

.ei-long-figure-scroll-auto {
  position: relative;
  width: 100%;
}

.scroll-content {
  position: relative;
  width: 1920px;
  height: 480px;
  white-space: nowrap;
  overflow: hidden;

  .scroll-list {
    position: absolute;
    left: 0;
    height: 100%;
    width: 300%;
    animation: scroll 10s linear infinite;

    .scroll-item {
      display: inline-block;
      float: right;
    }
  }
}

.filter-invert {
  filter: invert(100%);
}


.colorTurnsBlack {
  animation-name: colorTurnsBlackx;
  animation-duration: 30s;
  animation-iteration-count: infinite;
}

@keyframes colorTurnsBlackx {
  0% {
  }
  10% {
  }
  20% {
    filter: grayscale(100%) brightness(1%);
  }
  35% {
    filter: grayscale(0%) brightness(100%)
  }
  36% {
    filter: hue-rotate(0deg);
  }
  85% {
    filter: hue-rotate(360deg);
  }
  90% {
  }
  100% {
  }

}

.colorTurnsBlack-bg {

}


.nobgDiscoloration {
  animation-name: nobgcolor;
  animation-duration: 7s;
  animation-iteration-count: infinite;
  /*
    animation: ff 3s linear infinite;*/
}

@keyframes nobgcolor {
  to {
    filter: hue-rotate(360deg);
  }

}


.primaryColor {

}


.artistBlack {
  position: relative;
  animation-name: artistBlackx;
  animation-duration: 15s;
  animation-iteration-count: infinite;
}

.artistBlack-bg {

  position: relative;
  animation-name: artistBlackBg;
  animation-duration: 15s;
  animation-iteration-count: infinite;
}

@keyframes artistBlackBg {
  0% {
    background: rgb(250, 192, 0);
  }
  50% {
    background: #FFE66F;
  }
  100% {
    background: rgb(250, 192, 0);
  }
}

@keyframes artistBlackx {
  0% {
    filter: grayscale(100%) brightness(1%);
  }
  50% {
    filter: grayscale(0%);
  }
  100% {
    filter: grayscale(100%) brightness(1%);
  }
}


.blackGloden {
  filter: invert(100%) saturate(400%);
}

.blackGloden-bg {
  background-color: black;
}


.whiteText {
  position: relative;
  /*top: -900px;
  -webkit-filter: drop-shadow(0px 900px white);
  filter: drop-shadow(0px 900px white);*/
  filter: grayscale(100%) brightness(20%) invert(100%);
}

.whiteText-bg {
  overflow: hidden;
  background-color: black;
  height: 480px;
  /*animation-name: whiteText;
  animation-duration: 10s;
  animation-iteration-count: infinite;*/
}


.blackText {
  position: relative;
  filter: brightness(20%)

}

.blackText-bg {
  overflow: hidden;
  height: 480px;
}

.blackYellow {
  position: relative;
  animation-name: blackYellowText;
  animation-duration: 11.5s;
  animation-iteration-count: infinite;
}

@keyframes blackYellowText {
  0% {
    filter: grayscale(100%) brightness(15%);
  }
  50% {
    filter: grayscale(0%);
  }
  100% {
    filter: grayscale(100%) brightness(15%);
  }
}


.blackYellow-bg {
  overflow: hidden;
  background-color: rgb(250, 192, 0);
  height: 480px;
  animation-name: blackyellowTextBg;
  animation-duration: 15s;
  animation-iteration-count: infinite;
}

@keyframes blackyellowTextBg {
  0% {
    background: rgb(250, 192, 0)
  }
  20% {
    background: rgb(250, 192, 0)
  }
  50% {
    background: #dec674
  }
  100% {
    background: rgb(250, 192, 0)
  }
}


@keyframes nobgcolor {
  from {
    filter: hue-rotate(0deg)
  }
  to {
    filter: hue-rotate(360deg)
  }
}

.nobgDiscoloration {
  animation-name: nobgcolor;
  animation-duration: 15s;
  animation-iteration-count: infinite;
}


@keyframes bgcolor {
  from {
    filter: hue-rotate(0deg)
  }
  to {
    filter: hue-rotate(360deg)
  }
}

.haveBgDiscoloration {
  animation-name: bgcolor;
  animation-duration: 20s;
  animation-iteration-count: infinite;
}

.haveBgDiscoloration-bg {
  background-color: #FF9797;
}

.scroll-white {
  position: absolute;
  top: 0;
  left: 0;
  width: var(--width);
  height: 483px;
  box-shadow: 0 5px 5px 0 rgba(0, 0, 0, 0.05);
  background-color: #fff;
}

.scroll-bg {
  position: absolute;
  width: 1903px;
  height: 480px;
  overflow: hidden;
  top: 0;
  left: 0;
  background-color: #fff;
  animation-name: scrollBg;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-fill-mode: forwards;
  animation-play-state: running;
}



.ei-long-figure-scroll:hover .scroll-list {
  animation-play-state: paused;
}


.ei-long-figure-scroll:hover .scroll-text {
  animation-play-state: paused;
}

.ei-long-figure-scroll:hover .scroll-bg {
  animation-play-state: paused;
}
.ei-long-figure-scroll:hover .jindutiao {
  animation-play-state: paused;
}

.bottom-scroll-text {
  width: 1903px;
  overflow: hidden;
  height: 60px;
  position: relative;

  img {
    position: absolute;
  }

  img:nth-child(2) {
    position: absolute;
    right: 0;
    transform: scaleX(-1);
  }

  .scroll-text {
    background: linear-gradient(40deg,#2E8B57, #191970,#00BFFF,#8B0000,#000000,#2E8B57, #191970,#00BFFF,#8B0000,#000000,#2E8B57, #191970,#00BFFF,#8B0000,#000000,#2E8B57, #191970,#00BFFF,#8B0000,#000000,#2E8B57, #191970,#00BFFF,#8B0000,#000000,#2E8B57, #191970,#00BFFF,#8B0000,#000000,#2E8B57, #191970,#00BFFF,#8B0000,#000000,#2E8B57, #191970,#00BFFF,#8B0000,#000000,#2E8B57, #191970,#00BFFF,#8B0000,#000000,#2E8B57, #191970,#00BFFF,#8B0000,#000000,#2E8B57, #191970,#00BFFF,#8B0000,#000000,#2E8B57, #191970,#00BFFF,#8B0000,#000000,#2E8B57, #191970,#00BFFF,#8B0000,#000000,#2E8B57, #191970,#00BFFF,#8B0000,#000000,#2E8B57, #191970,#00BFFF,#8B0000,#000000,#2E8B57, #191970,#00BFFF,#8B0000,#000000,#2E8B57, #191970,#00BFFF,#8B0000,#000000,#2E8B57, #191970,#00BFFF,#8B0000,#000000,#2E8B57, #191970,#00BFFF,#8B0000,#000000,#2E8B57, #191970,#00BFFF,#8B0000,#000000,#2E8B57, #191970,#00BFFF,#8B0000,#000000,#2E8B57, #191970,#00BFFF,#8B0000,#000000,#2E8B57, #191970,#00BFFF,#8B0000,#000000);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    position: absolute;
    font-size: 30px;
    white-space: nowrap;
    animation: scrollText linear infinite;
    animation-duration: 10s;
    font-family: fantasy;
  }
}

* img, span, a, div {
  user-select: none;
  -webkit-user-drag: none;
}
</style>
